import { Quaternion, Vector3 } from 'three';

const LABEL_NORMAL = new Vector3(0, 0, 1);
const SCREEN_UP = new Vector3(0, 1, 0);

/** Rotation by a number of quarter turns about a label's own normal. */
export function quarterTurn(turns: number): Quaternion {
  return new Quaternion().setFromAxisAngle(LABEL_NORMAL, (turns * Math.PI) / 2);
}

/**
 * Quarter turns (0–3) about a face label's normal that make its text read most
 * upright. `worldQuaternion` is the label's unturned orientation in the cube's
 * scene, whose camera looks down -Z with +Y up. The current turn is kept unless
 * another beats it by `margin`, so a label doesn't flicker near 45°.
 */
export function uprightTurns(worldQuaternion: Quaternion, current = 0, margin = 0.1): number {
  const score = (turns: number): number =>
    new Vector3(0, 1, 0).applyQuaternion(quarterTurn(turns)).applyQuaternion(worldQuaternion).dot(SCREEN_UP);
  let best = current;
  let bestScore = score(current) + margin;
  for (let turns = 0; turns < 4; turns++) {
    const s = score(turns);
    if (s > bestScore) {
      best = turns;
      bestScore = s;
    }
  }
  return best;
}
